import { FormSelect } from "@/components/forms/FormSelect";
import { ALL_UNITS_OPTIONS } from "@/features/units/schema";

export function UnitsSelect({ name, label, sx }) {
  return (
    <FormSelect name={name} label={label} options={ALL_UNITS_OPTIONS} sx={sx} />
  )
}
